<template>
  <!--begin::Dashboard-->

  <div
    class="col-12 aos-init aos-animate content mx-auto"
    data-aos="fade-up"
    data-aos-delay="100"
  >
    <div class="titulo-pagina mt-10 mb-10 text-lg-left text-sm-center">
      <span>DATOS </span><span>FILTRO</span>
    </div>
    <!-- <h2>búsqueda avanzada</h2> -->
    <div class="card-femsa mb-5 d-flex flex-row mb-4">
      <div class="card-body py-3 px-8">
        <div class="row">
          <div class="col-sm-12 col-md-4 mt-5 mt-lg-0">
            <label for="info-rutCliente" class="label-femsa mb-2"
              >Rut Cliente</label
            >
            <input
              class="form-control form-control-femsa"
              id="info-rutCliente"
              name="rutCliente"
              v-model="rutEmpresaCliente"
              required
              placeholder="Ingresar el rut completo 11111111-1"
              type="text"
            />
          </div>

          <div class="col-sm-12 col-md-4 mt-5 mt-lg-0">
            <label for="info-rutEmpresaConvenio" class="label-femsa mb-2"
              >Rut Empresa Comvenio</label
            >
            <input
              class="form-control form-control-femsa"
              id="info-rutEmpresaConvenio"
              name="rutEmpresaConvenio"
              v-model="rutEmpresaConvenio"
              required
              placeholder="Ingresar el rut completo 11111111-1"
              type="text"
            />
          </div>

          <div class="col-sm-12 col-md-4 mt-5 mt-lg-0">
            <label for="vistas" class="label-femsa mb-2">Vistas</label>
            <b-form-select
              id="vistas"
              v-model="vistaSeleccionada"
              :options="vistas"
              value-field="value"
              text-field="text"
              class="custom-select text-capitalize"
            >
              <!-- <option value="" class="text-capitalize">Todos</option> -->
            </b-form-select>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-5">
          <button class="btn-primary-femsa mr-5" @click="onSubmit">
            Buscar
          </button>
          <button class="btn-primary-femsa" @click="limpiar">Limpiar</button>
        </div>
      </div>
    </div>

    <div>
      <Pago
        :rutEmpresaConvenio="rutEmpresaConvenio"
        :rutEmpresaCliente="rutEmpresaCliente"
        :empresa="empresa"
        v-if="mostrarPagos"
        :key="pagoKey"
      />
      <Orders
        v-if="mostrarOrdenes"
        :rutEmpresa="rutEmpresaCliente"
        :empresa="empresa"
        :key="ordersKey"
      />
    </div>
  </div>

  <!--end::Dashboard-->
</template>

<script>
// import { mapState } from "vuex";
import Pago from "./PagoVistaAdministrador.vue";
import Orders from "./Orders.vue";
import { GET_COMPANY_RUT_EMPRESA } from "@/core/services/store/company.module";
export default {
  name: "vista-cliente",
  components: {
    Pago,
    Orders,
  },
  data() {
    return {
      loading: false,
      empresa: {},
      rutEmpresaCliente: "",
      rutEmpresaConvenio: "77712318-1",
      mostrarPagos: false,
      mostrarOrdenes: false,
      vistas: [
        { text: "Pagos", value: "pagos" },
        { text: "Pedidos", value: "pedidos" },
      ],
      vistaSeleccionada: "pagos",
      pagoKey: 0,
      ordersKey: 0,
    };
  },
  mounted() {},

  methods: {
    limpiar() {
      this.$nextTick(() => {
        this.rutEmpresaCliente = null;

        this.mostrarPagos = false;

        this.mostrarOrdenes = false;
      });
    },
    obtenerEmpresa() {
      this.$store
        .dispatch(GET_COMPANY_RUT_EMPRESA, this.rutEmpresaCliente)
        .then((response) => {
          this.empresa = response;
        })
        .catch(function () {
          this.loading = false;
        });
    },
    onSubmit() {
      if (this.rutEmpresaCliente == null || this.rutEmpresaCliente == "") {
        return false;
      }

      if (this.rutEmpresaConvenio == null || this.rutEmpresaConvenio == "") {
        return false;
      }
      this.obtenerEmpresa();
      this.$nextTick(() => {
        this.mostrarPagos = false;
        this.mostrarOrdenes = false;
        if (this.vistaSeleccionada == "pagos") {
          this.mostrarPagos = true;
          this.mostrarOrdenes = false;
          this.pagoKey += 1;
        }
        if (this.vistaSeleccionada == "pedidos") {
          this.mostrarOrdenes = true;
          this.mostrarPagos = false;
          this.ordersKey += 1;
        }
      });
    },
  },
};
</script>

